import Icon from '@ant-design/icons/lib/components/Icon';
import * as React from 'react';
const IThirdParties = (props: any) => {
  return (
    <Icon
      component={() => {
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="21"
            height="22"
            viewBox="0 0 21 22"
            fill="none"
          >
            <path
              d="M1.79321 12.5519C1.86552 10.7351 2.86336 6.57766 6.27626 4.48242"
              stroke={props.color??"#37474F"}
              strokeWidth="1.5"
              strokeLinecap="round"
            />
            <circle
              cx="9.63853"
              cy="2.46568"
              r="1.71568"
              stroke={props.color??"#37474F"}
              strokeWidth="1.5"
            />
            <circle
              cx="2.46568"
              cy="16.3622"
              r="1.71568"
              stroke={props.color??"#37474F"}
              strokeWidth="1.5"
            />
            <circle
              cx="17.7081"
              cy="15.0184"
              r="1.71568"
              stroke={props.color??"#37474F"}
              strokeWidth="1.5"
            />
            <path
              d="M13.0007 4.48242C14.1328 4.85026 16.6143 6.62049 17.4838 10.7587"
              stroke={props.color??"#37474F"}
              strokeWidth="1.5"
              strokeLinecap="round"
            />
            <path
              d="M4.9314 19.3997C6.71773 20.437 11.2808 21.775 15.2424 18.8281"
              stroke={props.color??"#37474F"}
              strokeWidth="1.5"
              strokeLinecap="round"
            />
          </svg>
        );
      }}
      {...props}
    />
  );
};

export default IThirdParties;
